export function stripDiacritics(s: string): string {
  return s
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D");
}

// Emoji/ký hiệu hình ảnh: trang web (Facebook…) render thành <img>, không còn trong chữ → bỏ khỏi so khớp ở cả hai phía.
const EMOJI = /[\p{Extended_Pictographic}\p{Emoji_Presentation}\uFE0F\u200D]/gu;
export function stripEmoji(s: string): string {
  return s.replace(EMOJI, "");
}

export function normText(s: string): string {
  return stripDiacritics(stripEmoji(s)).toLowerCase().replace(/\s+/g, " ").trim();
}

export function normExact(s: string): string {
  return stripEmoji(s).toLowerCase().replace(/\s+/g, " ").trim();
}

export function containsKeyword(text: string, keywords: readonly string[]): string | null {
  const t = normText(text);
  if (!t) return null;
  for (const k of keywords) {
    const nk = normText(k);
    if (nk && t.includes(nk)) return k;
  }
  return null;
}
